import { comparer } from 'mobx';

export function equals(a: any, b: any): boolean {
  return comparer.structural(a, b);
}
